import theme from "@config/theme";

type TagsProps = {
  tags: string[];
};

const Tags = ({ tags }: TagsProps) => (
  <>
    <ul className="tags">
      {tags.map((tag, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <li key={index}>{tag}</li>
      ))}
    </ul>
    <style jsx>
      {`
        ul {
          list-style: none;
          display: inline;
          padding: 0;
        }
        .tags {
          display: flex;
          flex-wrap: wrap;
          row-gap: 10px;
          margin-top: 12px;
        }
        .tags li {
          display: inline-block;
          padding: 0 8px;
          margin: 0 6px 0 0;
          font-size: ${theme.fonts.size.px12};
          text-align: center;
          white-space: nowrap;
          border-radius: 4px;
          background-color: ${theme.colors.devGray};
        }
      `}
    </style>
  </>
);

export default Tags;
